/* eslint-disable jsdoc/check-param-names */
import { Dispatch, ReactNode, SetStateAction } from "react";
import { Box, Stack, SxProps, TextField, Typography } from "@mui/material";

type Props = {
  label: string;
  children: ReactNode;
  required?: boolean;
  description?: string | string[];
  descriptionSx?: SxProps;
};

/**
 * ラベルのあるテキスト
 * @param label ラベル
 * @param required 必須かどうか
 * @returns JSX.Element
 */
export default function LabeledComponent({
  label,
  children,
  required,
  description,
  descriptionSx,
}: Props) {
  const isDescriptionArray = Array.isArray(description);
  return (
    <Stack
      direction="row"
      spacing={2}
      alignItems="center"
      justifyContent="center"
      position="relative"
      height={isDescriptionArray ? 26 + description.length * 24 : 50}
      width={0}
      margin="0 auto"
    >
      <Box textAlign="right" marginRight={1} position="absolute" right={10} width="max-content">
        {label}
        {required && <Typography color="red">{" *"}</Typography>}：
      </Box>
      <Box
        position="absolute"
        width="max-content"
        minWidth={207}
        left={12}
        display="flex"
        flexDirection="row"
      >
        {children}
        {description &&
          (isDescriptionArray ? (
            <Box textAlign="left">
              {description.map((d) => (
                <Typography marginLeft={2} alignSelf="left" sx={descriptionSx ?? {}}>
                  {d}
                </Typography>
              ))}
            </Box>
          ) : (
            <Typography marginLeft={2} alignSelf="center" sx={descriptionSx ?? {}}>
              {description}
            </Typography>
          ))}
      </Box>
    </Stack>
  );
}
